import { ApolloClient, InMemoryCache } from '@apollo/client';
import { WebSocketLink } from "@apollo/client/link/ws";
const link = new WebSocketLink({
  uri: `wss://${process.env.REACT_APP_HASURA_URI}`,
  options: {
    reconnect: true,
    connectionParams: {
      headers: {
        'content-type': 'application/json',
        'x-hasura-admin-secret': process.env.REACT_APP_HASURA_KEY
      },
    },
  },
});
const cache = new InMemoryCache();
const graphQLClient = new ApolloClient({
  link,
  cache,
});

export { graphQLClient };